<template>
  <div>
    <div ref="chartContainer" style="width: 100%;height: 300px;padding-top: 20px"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import {getMonthDay} from "@/utils/dateUtils";
import {getDayOrderCountApi, getMonthOrderCountApi} from "@/api/orderApi";

export default {
  name: "MonthOrder",
  data() {
    return {
      dataArr:[],
      travelDataArr: [],
      chartOptions:  {
        title: {
          left: 'center',
          text: '近30天订单数(笔)'
        },
        xAxis: {
          type: 'category',
          data: getMonthDay().reverse()
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          trigger: 'axis',
        },
        series: [
          {
            name:"商品",
            data: [],
            type: 'line',
            smooth: true
          }
        ]
      }
    }
  },
  methods: {
    async getMonthOrderCount(){
      this.dataArr=[];
      // this.travelDataArr=[];
      let {data:res}=await getMonthOrderCountApi();
      let arr=[]
      // let arrTravel=[]
      res.forEach(e=>{
        arr.push(e.count);
        //  arrTravel.push(e.travelCount);
      })
      this.dataArr=arr
      // this.travelDataArr=arrTravel
    },
    async initChart() {
      // 获取图表容器
      let chartContainer = this.$refs.chartContainer;
      // 初始化图表
      let myChart = echarts.init(chartContainer);
      await this.getMonthOrderCount();
      this.chartOptions.series[0].data=this.dataArr;
      //this.chartOptions.series[1].data=this.travelDataArr;
      // 使用 setOption 方法设置图表配置和数据
      myChart.setOption(this.chartOptions);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    })
  }
}
</script>


<style scoped>

</style>
